import restApi from "../../http.js";
import session from "../session";
import env from "../../env.js";

export default class BrandApi {
  getPublicBrand(id) {
    return restApi({
      method: "GET",
      url: "/brands/" + id + "/public",
    });
  }

  getBrand(id) {
    return restApi({
      method: "GET",
      url: "/brands/" + id,
      headers: {
        Authorization: "Bearer " + session.getAccessToken(),
      },
    });
  }

  getBrandBySlug(slug) {
    return restApi({
      method: "GET",
      url: "/brands/brand-bio/" + slug,
    });
  }

  createBrand(request) {
    return restApi({
      method: "POST",
      url: "/brands",
      data: request,
      headers: {
        Authorization: "Bearer " + session.getAccessToken(),
      },
    });
  }

  updateBrand(request) {
    return restApi({
      method: "PATCH",
      url: "/brands/" + request.id,
      data: request,
      headers: {
        Authorization: "Bearer " + session.getAccessToken(),
      },
    });
  }

  updateBrandMe(request) {
    return restApi({
      method: "PATCH",
      url: "/brands/me",
      data: request,
      headers: {
        Authorization: "Bearer " + session.getAccessToken(),
      },
    });
  }

  getBrandMe() {
    return restApi({
      method: "GET",
      url: "/brands/me",
      headers: {
        Authorization: "Bearer " + session.getAccessToken(),
      },
    });
  }

  uploadBrandImage(data, id) {
    return restApi({
      method: "POST",
      url: "/brands/" + id + "/image",
      data: data,
      headers: {
        Authorization: "Bearer " + session.getAccessToken(),
      },
    });
  }
  uploadBrandThumb(data, id) {
    return restApi({
      method: "POST",
      url: "/brands/" + id + "/thumbnail",
      data: data,
      headers: {
        Authorization: "Bearer " + session.getAccessToken(),
      },
    });
  }
  uploadBrandImageMe(data) {
    return restApi({
      method: "POST",
      url: "/brands/my-image",
      data: data,
      headers: {
        Authorization: "Bearer " + session.getAccessToken(),
      },
    });
  }
  uploadBrandThumbMe(data) {
    return restApi({
      method: "POST",
      url: "/brands/my-thumbnail",
      data: data,
      headers: {
        Authorization: "Bearer " + session.getAccessToken(),
      },
    });
  }
  uploadBrandImageMyThumbnail(data) {
    return restApi({
      method: "POST",
      url: "/brands/my-thumbnail",
      data: data,
      headers: {
        Authorization: "Bearer " + session.getAccessToken(),
      },
    });
  }

  onboardingFormSubmit(request) {
    return restApi({
      method: "POST",
      url: "/brands/onboarding-form",
      data: request,
    });
  }

  outboundOnboardingFormSubmit(request) {
    return restApi({
      method: "POST",
      url: "/brands/outbound-onboarding-form",
      data: request,
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  }

  onboardingFormSubmitAirtable(request) {
    return restApi({
      method: "POST",
      url: "https://api.airtable.com/v0/appaZ6emMytQ6RrHD/Table%201",
      data: {
        fields: {
          Name: request.brand_name,
          Instagram: request.instagram,
          "Approximate number of Instagram followers": request.instagram_followers,
          "Address":JSON.stringify(request.address),
          "Brand owner/founder name": `${request.owner_first_name} ${request.owner_last_name}`,
          "Website URL": request.website_url,
          "Brand point-of-contact email address": request.email,
          "City you are based in": request.address.city,
          "City you are shipping from": request.shipping_city,
          "Years in business": request.years_in_business,
          "Please describe your own direct-to-consumer/ecommerce customer in a sentence or two":
            request.customer_description,
          "What product categories do you offer? Please select all that apply": request.categories,
          "Lead Times": request.lead_time,
          "Minimum order value": request.minimum_order_value,
          "Reorder minimum order value": request.minimum_reorder_value,
          "MOQ": request.moq,
          "Ship to Canada": request.ship_to_canada,
          "Please provide URL links for your top 5 bestsellers": request.bestsellers,
          "Product photography": request.product_photography,
          "Your brand story": request.brand_bio,
          "Please link out to your wholesale linesheet, or a website that contains your wholesale pricing":
            request.line_sheet_url,
          "A profile picture to represent you / your brand": [request.thumbnail_image_url],
          "Please provide your W9": [request.w9_url],
          "Editorial and lifestyle images": request.editorial,
          "Please select all that apply to your brand": request.values,
          "Would you be open to fulfilling an order that was under your minimum?": request.order_under_mov,
          "If you are newer to wholesale or prefer we use your consumer site, please link out to your consumer-facing site above and use the checkbox below to indicate we should take 50% off MSRP to calculate wholesale pricing":
            request.msrp,
          "Important! Wholesale notes or parameters we should know": request.wholesale_notes,
          "Initial 100 SKUs": request.initial_skus,
          "Brand ID": request.brand_id,
          "Case Pack Quantity": request.case_pack_quantity,
        },
        typecast: true,
      },
      headers: {
        Authorization: "Bearer " + env.airTableToken(),
      },
    });
  }

  uploadDocs(request, code = '') {
    return restApi({
      method: "POST",
      url: "/brands/docs?code=" + code,
      data: request,
    });
  }

  uploadDocs2(request) {
    return restApi({
      method: "POST",
      url: "/brands/docs?code=",
      data:  request,
    });
  }

  getInfoFromCode(code) {
    return restApi({
      method: "GET",
      url: "/brands/apply-to-sell-details",
      params: {
        code: code,
      },
    });
  }

  approve(id) {
    return restApi({
      method: "PATCH",
      url: `/brands/${id}/approve`,
      headers: {
        Authorization: "Bearer " + session.getAccessToken(),
      },
    });
  }

  getBrandValues() {
    return restApi({
      method: "GET",
      url: "/brands/values/dropdown",
    });
  }

  getBrandStockist(id) {
    return restApi({
      method: "GET",
      url: `/brands/${id}/stockists`,
    });
  }

  getMyBrandPromoCodes() {
    return restApi({
      method: "GET",
      url: `/brands/promo-codes/active`,
      headers: {
        Authorization: "Bearer " + session.getAccessToken(),
      },
    });
  }

  getBrandsFromCategoryContainerId(containerId) {
    return restApi({
      method: "GET",
      url: `/brands/container/${containerId}/dropdown`,
    });
  }
  getBrandsFromCategoryComponentId(componentId) {
    return restApi({
      method: "GET",
      url: `brands/component/${componentId}/dropdown`,
    });
  }
  // TODO delete
  getCategoriesOwnedByBrand(brandId) {
    return restApi({
      method: "GET",
      url: `/brands/${brandId}/categories`,
    });
  }

  getOnboardingCodes(brandIds) {
    return restApi({
      method: "POST",
      url: "/brands/onboarding-codes",
      data: {
        ids: brandIds
      },
      headers: {
        Authorization: "Bearer " + session.getAccessToken(),
      },
    });
  }
}
